import { AuthGuard } from '../../shared/guard/auth.guard';
import { Injectable } from '@angular/core';
import {AngularFireDatabase, AngularFireList,  AngularFireObject} from '@angular/fire/database';
import * as firebase from 'firebase';
import {Business} from '../../models/business';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import {Bplan} from '../../models/bplan';



@Injectable({
  providedIn: 'root'
})
export class FireBplanService {
  bplansRef: AngularFireList<any>; // Reference to Assessment data list, its an Observable
  bplanRef: AngularFireObject<any>; // Reference to assessment object
  public database = firebase.database();
  public UserBplansInput;
  public ref;
  public actRoute: ActivatedRoute;
  public router: Router;
  public auth: AuthGuard;
  public dbStore = firebase.firestore();
  private pBlanPath = 'user-bPlan';



   
  sustainibleBPlanRef : AngularFirestoreCollection<Bplan>=null;



  constructor (private db: AngularFireDatabase, private guard: AuthGuard,private dbstore: AngularFirestore ) {
    this.sustainibleBPlanRef = dbstore.collection(this.pBlanPath);
   }

   
   // Firestore Assessment Create the Assessment in FireStore
   createSustainibleBplan ( bplan:Bplan):void {
     this.sustainibleBPlanRef.add({...bplan});
       
   }

   updateSustainibleBplan ( id:string, value:any): Promise <void> {
    return this.sustainibleBPlanRef.doc(id).update(value);

   }

   deleteSustainibleBplan (id:string) : Promise <void> {
    return this.sustainibleBPlanRef.doc(id).delete();

   }

   readSustainibleBplanList ():AngularFirestoreCollection<Bplan> {
    return this.sustainibleBPlanRef;

   }

public bPlandata: any;
public  data1!: any;
  readSustainibleBplan(id:string) {
    debugger
    //this.sustainibleBPlanRef.collection('bPlan').doc(this.busiPlanID).get().toPromise().then((payload: any) => {
    //  this.bplanBusiName = payload?.data()?.bplanBusiName;
      // this.sustainibleBPlanRef.doc(id).get().toPromise().then((doc) => {
      // this.bPlandata =  doc.data();
        //define all variables of a single assessment
      this.bPlandata.ref = this.sustainibleBPlanRef.doc(id);
      JSON.stringify(this.bPlandata.ref);
      this.bPlandata.ref.once("value").then((snapshot) => {
        this.data1 = snapshot.val(); 
        console.log("bPlandata" + this.data1)
      });
    }
      
     
  

   deleteAllSustainibleBplan () {
     this.sustainibleBPlanRef.get().subscribe(
       querySnapshot => {
         querySnapshot.forEach((doc) =>{
           doc.ref.delete();
         });
       },
       error=>{
         console.log('Error deleting all documents: ', error);
       });
   }

    /**
   * Create assessment in firestore
   * @param bPlan - data about bPlan assessment
   * @returns 
   */


  // create assessment
  async createBplan(bPlan: Bplan): Promise<string>  {
    //const key = this.database.ref('/users').push().key; // is this what's causing it? assementref.push..its pushing the key under the uid and on the database
    const adminCode = (await this.dbStore.collection(this.pBlanPath).doc(this.guard.uid).get())?.data()?.adminCode;
    const res = await this.sustainibleBPlanRef.add({
        adminCode: adminCode || null,//problem
        userID: this.guard.uid,//problem
        bplanBusiName: bPlan.bplanBusiName,
        bplanBusiStreet: bPlan.bplanBusiStreet,
        bplanBusiStreet2: bPlan.bplanBusiStreet2,
        bplanBusiCity: bPlan.bplanBusiCity,
        bplanBusiState: bPlan.bplanBusiState,
        bplanBusiZipcode: bPlan.bplanBusiZipcode,
        bplanBusiType: bPlan.bplanBusiType,
        bplanOfferSummary: bPlan.bplanOfferSummary,
        bplanCustomerPersonaSummary: bPlan.bplanCustomerPersonaSummary,
        bplanBusiOfferType: bPlan.bplanBusiOfferType,
        bplanCustomerLocation: bPlan.bplanCustomerLocation,
        bplanBusiOperationsType: bPlan.bplanBusiOperationsType,
        bPlanCustomerCharacterstic: bPlan.bPlanCustomerCharacterstic,
        bplanCustomerAppeal: bPlan.bplanCustomerAppeal,
        bplanTeamNames: bPlan.bplanTeamNames,
        bplanTeamSummary: bPlan.bplanTeamSummary,
        bPlanMarketingSummary: bPlan.bPlanMarketingSummary,
        bplanLongTermGoals: bPlan.bplanLongTermGoals,
        bPlanMission: bPlan.bPlanMission,
        bPlanMissionExpanded: bPlan.bPlanMissionExpanded,
        bplanKeysToSuccess: bPlan.bplanKeysToSuccess,
        bPlanIndustryType: bPlan.bPlanIndustryType,
        bplanBusinessAge: bPlan.bplanBusinessAge,
        bplanBusiRegStatus: bPlan.bplanBusiRegStatus,
        bplanBusiRegType: bPlan.bplanBusiRegType,
      bPlanOfferArray: bPlan.bPlanOfferArray,
      bplanBusiOfferPriceDeterminant: bPlan.bplanBusiOfferPriceDeterminant,
      bPlanOfferingExpansion: bPlan.bPlanOfferingExpansion,
      bPlanMarketDemographicNotes: bPlan.bPlanMarketDemographicNotes,
      bPlanMarketResearchNotes: bPlan.bPlanMarketResearchNotes,
      bPlanMarketDescription: bPlan.bPlanMarketDescription,
      bPlanMarketTargetSummary: bPlan.bPlanMarketTargetSummary,
      bPlanIndustryAnalysis: bPlan.bPlanIndustryAnalysis,
      bPlanCompetitionDescription: bPlan.bPlanCompetitionDescription,
      bplanBusiMarketStrategy: bPlan.bplanBusiMarketStrategy,
      bplanBusiMarketStrategyDescription: bPlan.bplanBusiMarketStrategyDescription,
      bPlanBusiSalesStrategyDescription: bPlan.bPlanBusiSalesStrategyDescription,
      bplanCustomerStatus: bPlan.bplanCustomerStatus,
      bPlanBusiSalesForecastDescription: bPlan.bPlanBusiSalesForecastDescription,
      bplanMilestoneTimeline: bPlan.bplanMilestoneTimeline,
      bplanShortTermGoals: bPlan.bplanShortTermGoals,
      bplanDifferentiationList: bPlan.bplanDifferentiationList,
      bPlanDifferentiationExpansion: bPlan.bPlanDifferentiationExpansion,
      bplanPersonnelPlan: bPlan.bplanPersonnelPlan,
      });

      return res.id;
  
    }

 

  ReadBplan(id: string) {
    this.bplanRef = this.db.object(`users/${this.guard.uid}/` + id);
    return this.bplanRef;
  }

  ReadBplanList() {
    this.bplansRef = this.db.list(`users/${this.guard.uid}/`);
    return this.bplansRef;
  }
  UpdateBplan(bPlan: Bplan) {
    this.bplanRef.update({
        bplanBusiName: bPlan.bplanBusiName,
        bplanBusiStreet: bPlan.bplanBusiStreet,
        bplanBusiStreet2: bPlan.bplanBusiStreet2,
        bplanBusiCity: bPlan.bplanBusiCity,
        bplanBusiState: bPlan.bplanBusiState,
        bplanBusiZipcode: bPlan.bplanBusiZipcode,
        bplanBusiType: bPlan.bplanBusiType,
        bplanOfferSummary: bPlan.bplanOfferSummary,
        bplanCustomerPersonaSummary: bPlan.bplanCustomerPersonaSummary,
        bplanBusiOfferType: bPlan.bplanBusiOfferType,
        bplanCustomerLocation: bPlan.bplanCustomerLocation,
        bplanBusiOperationsType: bPlan.bplanBusiOperationsType,
        bPlanCustomerCharacterstic: bPlan.bPlanCustomerCharacterstic,
        bplanCustomerAppeal: bPlan.bplanCustomerAppeal,
        bplanTeamNames: bPlan.bplanTeamNames,
        bplanTeamSummary: bPlan.bplanTeamSummary,
        bPlanMarketingSummary: bPlan.bPlanMarketingSummary,
        bplanLongTermGoals: bPlan.bplanLongTermGoals,
        bPlanMission: bPlan.bPlanMission,
        bPlanMissionExpanded: bPlan.bPlanMissionExpanded,
        bplanKeysToSuccess: bPlan.bplanKeysToSuccess,
        bPlanIndustryType: bPlan.bPlanIndustryType,
        bplanBusinessAge: bPlan.bplanBusinessAge,
        bplanBusiRegStatus: bPlan.bplanBusiRegStatus,
        bplanBusiRegType: bPlan.bplanBusiRegType,
      bPlanOfferArray: bPlan.bPlanOfferArray,
      bplanBusiOfferPriceDeterminant: bPlan.bplanBusiOfferPriceDeterminant,
      bPlanOfferingExpansion: bPlan.bPlanOfferingExpansion,
      bPlanMarketDemographicNotes: bPlan.bPlanMarketDemographicNotes,
      bPlanMarketResearchNotes: bPlan.bPlanMarketResearchNotes,
      bPlanMarketDescription: bPlan.bPlanMarketDescription,
      bPlanMarketTargetSummary: bPlan.bPlanMarketTargetSummary,
      bPlanIndustryAnalysis: bPlan.bPlanIndustryAnalysis,
      bPlanCompetitionDescription: bPlan.bPlanCompetitionDescription,
      bplanBusiMarketStrategy: bPlan.bplanBusiMarketStrategy,
      bplanBusiMarketStrategyDescription: bPlan.bplanBusiMarketStrategyDescription,
      bPlanBusiSalesStrategyDescription: bPlan.bPlanBusiSalesStrategyDescription,
      bplanCustomerStatus: bPlan.bplanCustomerStatus,
      bPlanBusiSalesForecastDescription: bPlan.bPlanBusiSalesForecastDescription,
      bplanMilestoneTimeline: bPlan.bplanMilestoneTimeline,
      bplanShortTermGoals: bPlan.bplanShortTermGoals,
      bplanDifferentiationList: bPlan.bplanDifferentiationList,
      bPlanDifferentiationExpansion: bPlan.bPlanDifferentiationExpansion,
      bplanPersonnelPlan: bPlan.bplanPersonnelPlan,
    });
  }
  DeleteBplan() {
    this.bplanRef = this.db.object('users/');
    this.bplanRef.remove();
  }

}